export default "__VITE_ASSET__D8yIPZ7f__"